"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var StatusDropdownComponent_1 = require("./StatusDropdownComponent");
var StatusComponent = function (props) {
    var onAboveChange = function (value) {
        props.onStatusChange(__assign(__assign({}, props.status), { above: value }));
    };
    var onBelowChange = function (value) {
        props.onStatusChange(__assign(__assign({}, props.status), { below: value }));
    };
    var onAtChange = function (value) {
        props.onStatusChange(__assign(__assign({}, props.status), { equal: value }));
    };
    var color = props.disabled ? metrics_engine_1.MetricsDisabled : metrics_engine_1.MetricsGrey;
    return (React.createElement("div", null,
        React.createElement("p", { style: { fontWeight: 'bold', marginTop: 0, color: color } }, Localize_1.Messages.Status()),
        React.createElement("div", { style: { marginLeft: 20 } },
            React.createElement(StatusDropdownComponent_1.StatusDropdownComponent, { testId: 'above-value-options', label: Localize_1.Messages.AboveValue(), value: props.status.above, onChange: onAboveChange, disabled: props.disabled }),
            React.createElement(StatusDropdownComponent_1.StatusDropdownComponent, { testId: 'at-value-options', label: Localize_1.Messages.AtValue(), value: props.status.equal, onChange: onAtChange, disabled: props.disabled }),
            React.createElement(StatusDropdownComponent_1.StatusDropdownComponent, { testId: 'below-value-options', label: Localize_1.Messages.BelowValue(), value: props.status.below, onChange: onBelowChange, disabled: props.disabled }))));
};
exports.StatusComponent = StatusComponent;
//# sourceMappingURL=StatusComponent.js.map